import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import DashboardLayout from "./layouts/DashboardLayout";
import Inicio from "./pages/Inicio/Inicio";

import Usuarios from "./components/Admin/Usuarios/Usuarios";
import Roles from "./components/Admin/Roles/Roles";
import Vehiculo from "./components/Admin/Vehiculo/Vehiculo";

import Auth from "./components/Auth/Auth";

import Cliente from "./components/Admin/Cliente/Cliente";
import Empresa from "./components/Admin/Empresa/Empresa";
import Auditoria from "./components/Admin/Auditoria/Auditoria";
import Empleado from "./components/Admin/Empleado/Empleado";

import Producto from "./components/Admin/Productos/Producto";
import Categoria from "./components/Admin/Categorias/Categoria";

// INVENTARIO
import AjusteInventario from "./components/Admin/AjusteInventario/AjusteInventario";

// 👇 COTIZACIÓN (NUEVO)
import Cotizacion from "./components/Admin/Cotizacion/Cotizacion";
import AgregarCotizacion from "./components/Admin/AgregarCotizacion/AgregarCotizacion";

function App() {

  const [user, setUser] = useState(() => {
    return JSON.parse(localStorage.getItem("user"));
  });

  return (
    <Routes>

      {/* LOGIN */}
      <Route path="/" element={<Auth setUser={setUser} />} />

      {/* PROTEGIDO */}
      <Route
        path="/inicio"
        element={user ? <DashboardLayout /> : <Navigate to="/" replace />}
      >
        <Route index element={<Inicio />} />

        <Route path="usuarios" element={<Usuarios />} />
        <Route path="roles" element={<Roles />} />
        <Route path="vehiculo" element={<Vehiculo />} />

        <Route path="clientes" element={<Cliente />} />
        <Route path="empresa" element={<Empresa />} />

        <Route path="auditoria" element={<Auditoria />} />
        <Route path="empleado" element={<Empleado />} />

        <Route path="productos" element={<Producto />} />
        <Route path="categorias" element={<Categoria />} />

        <Route path="ajuste-inventario" element={<AjusteInventario />} />

        {/* 👇 COTIZACIÓN */}
        <Route path="cotizacion" element={<Cotizacion />} />
        <Route path="cotizacion/agregar" element={<AgregarCotizacion />} />

      </Route>

      {/* CATCH ALL */}
      <Route
        path="*"
        element={
          user ? <Navigate to="/inicio" replace /> : <Navigate to="/" replace />
        }
      />

    </Routes>
  );
}

export default App;